import { createActionCreator } from 'deox';

export const getUserInfoActions = {
  request: createActionCreator('USER_INFO_REQUEST', (resolve) => () => resolve()),
  success: createActionCreator(
    'USER_INFO_SUCCESS',
    (resolve) => (
      email: string,
      memberships: { organisationId: string; roleName: string }[],
      userId: string,
      firstName?: string,
      lastName?: string
    ) => resolve({ email, memberships, userId, firstName, lastName })
  ),
  failure: createActionCreator('USER_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const updateUserInfoActions = {
  request: createActionCreator(
    'UPDATE_USER_INFO_REQUEST',
    (resolve) => (firstName: string, lastName: string, userId: string) => resolve({ firstName, lastName, userId })
  ),
  success: createActionCreator('UPDATE_USER_INFO_SUCCESS', (resolve) => () => resolve()),
  failure: createActionCreator('UPDATE_USER_INFO_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const updateUserPasswordActions = {
  request: createActionCreator(
    'UPDATE_USER_PASSWORD_REQUEST',
    (resolve) => (currentPassword: string, password: string) => resolve({ password, currentPassword })
  ),
  success: createActionCreator('UPDATE_USER_PASSWORD_SUCCESS', (resolve) => () => resolve()),
  failure: createActionCreator('UPDATE_USER_PASSWORD_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
